import React, { useState, useRef } from 'react'
import { motion } from 'framer-motion'
import { cn } from '../../utils/ui'

export default function InteractiveHoverButton({
  children,
  className,
  onClick,
}) {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })
  const [isHovered, setIsHovered] = useState(false)
  const buttonRef = useRef(null)

  const handleMouseMove = (e) => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect()
      setMousePosition({
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      })
    }
  }

  return (
    <motion.button
      ref={buttonRef}
      className={cn(
        'relative px-8 py-4 bg-orange-500 border-2 border-orange-500 text-white text-lg font-medium rounded-xl overflow-hidden transition-all duration-300',
        'hover:bg-orange-400 hover:border-orange-400',
        className,
      )}
      onClick={onClick}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut',
      }}
    >
      {/* Animated background circle */}
      <motion.div
        className="absolute bg-white/20 rounded-full pointer-events-none"
        style={{
          width: '100px',
          height: '100px',
          left: mousePosition.x - 50,
          top: mousePosition.y - 50,
        }}
        animate={{
          scale: isHovered ? 1 : 0,
          opacity: isHovered ? 1 : 0,
        }}
        transition={{
          duration: 0.2,
          ease: 'easeOut',
        }}
      />

      {/* Button content */}
      <span className="relative z-10">{children}</span>
    </motion.button>
  )
}